import axios from 'axios';
import config from '../config';

export const getCheckDownloadLink = (id: string): Promise<string> => {
    const url = `${config.API_URL}/onboard-devices/checks/${id}/download`;
    return axios.get(url).then((response: any) => {
        return response.data.data.presigned_url;
    });
};
